<!--
 * @Description:  员工关系
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:32:18
-->
<template>
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <!-- 员工关系 -->
            <mrc_ess_autoComplete
              :label="$t('label_staff_correlation') + '*'"
              @changeStaffList="relationChange"
              :readonly="disabled"
              :errorMessages="$errors('list', 'correlation_uuid', requiredRule)"
              :prompt_name="staff_correlation"
              v-model="list.correlation_uuid"
            >
            </mrc_ess_autoComplete>
          </v-col>
          <v-col cols="12" sm="6">
            <!-- :readonly="disabled" -->
            <mrc_ess_multiText
              :label="$t('label_code')"
              readonly
              :backgroundColor="disabled ? '#fff' : 'rgb(245, 245, 245)'"
              :error-messages="
                $errors('list', 'correlation_code', requiredRule)
              "
              :isNational="judegNational('correlation_code')"
              v-model="list.correlation_code"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="6">
            <!--    :background-color="disabled?'':'#f5f5f5'" :disabled="Boolean($store.state.uuid)"-->
            <staff
              v-model="list.staff_uuid"
              itemValue="user_id"
              @changeStaff="changeStaffUuid"
              job_post_name="job_post_uuid"
              job_grade_name="job_post_grade_uuid"
              client_name="client_uuid"
              org_level_all="org_level_uuid"
              dept_name="dept_uuid"
              :error-messages="$errors('list', 'staff_uuid', requiredRule)"
              :dropDownList="dropDownList"
              :readonly="disabled"
              :multiple="false"
              :label="this.$t('label_A_departing_employee') + '*'"
            >
            </staff>
          </v-col>
          <v-col cols="12" sm="6">
            <!-- :disabled="Boolean($store.state.uuid)"
            :background-color="disabled?'':'#f5f5f5'" -->
            <!-- 被关联员工 -->
            <!-- <button @click="changestaffuuid">按钮sss</button> -->
            <!-- {{list.cr_staff_uuid}} -->
            <staff
              v-model="list.cr_staff_uuid"
              itemValue="user_id"
              @changeStaff="changeCrStaffUuid"
              job_post_name="job_post_uuid"
              job_grade_name="job_post_grade_uuid"
              client_name="client_uuid"
              org_level_all="org_level_uuid"
              dept_name="dept_uuid"
              :error-messages="$errors('list', 'cr_staff_uuid', requiredRule)"
              :dropDownList="dropDownListTwo"
              :readonly="disabled"
              :multiple="false"
              :label="this.$t('label_correlation_staff') + '*'"
            >
            </staff>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_datePicker
              :errMsg="$errors('list', 'effective_utc_datetime', requiredRule)"
              :disabled="disabled"
              afterDate
              :label="$t('label_effective_end_date') + '*'"
              v-model="list.effective_utc_datetime"
            >
            </mrc_ess_datePicker>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn
        @success="success"
        @cancel="cancel"
        :loading="btnIsLoading"
        v-if="!disabled"
      >
      </mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  staff_relation_config_add,
  staff_relation_config_edit,
  staff_relation_config_detail,
  get_staff_list,
} from "@/service/api/staffRelationConfig.js";
import { getBusinessList } from "@/service/api/prompt.js";
import staff from "./staff.vue";
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
export default {
  components: { staff },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      skeletonloading: true,
      dropDownList: [],
      dropDownListTwo: [],
      list: {
        cr_staff_uuid: "",
        staff_uuid: "",
        correlation_uuid: "",
        correlation_code: "",
      },
      btnIsLoading: false,
      viewList: {},
    };
  },
  computed: {
    company_uuid() {
      //当前选中公司
      return this.$store.state.currentCompany;
    },
    staff_correlation() {
      return {
        prompt_name: "staff_correlation",
        org_level_uuid: this.company_uuid,
      };
    },
  },
  async created() {},
  watch: {},
  async mounted() {
    this.national("mrbase_sys_correlation");
    // await getBusinessList({
    //   prompt_name: 'staff_correlation_user',
    //   other_staff_uuid: "",
    //   org_level_uuid: this.company_uuid
    // }).then(res => {
    // })
    get_staff_list({
      org_level_uuid: this.$store.state.currentCompany,
      filter: "StaffCorrelation-add" + "&" + this.list.cr_staff_uuid + "&",
    }).then((res) => {
      if (res.code == 200) {
        this.dropDownList = res.data;
      }
    });
    if (this.$store.state.uuid) {
      await this.getDetail();
      get_staff_list({
        org_level_uuid: this.$store.state.currentCompany,
        filter:
          "StaffCorrelation-add" +
          "&" +
          this.list.staff_uuid +
          "&" +
          this.$store.state.uuid,
      }).then((res) => {
        if (res.code == 200) {
          this.dropDownListTwo = res.data;
        }
      });
    } else {
    }
  },
  methods: {
    changestaffuuid() {
      // this.list.cr_staff_uuid = "0603d168-4594-48c8-be39-276baa67ea04"
    },
    changeCrStaffUuid(val) {},
    changeStaffUuid(val) {
      get_staff_list({
        org_level_uuid: this.$store.state.currentCompany,
        filter:
          "StaffCorrelation-add" + "&" + val + "&" + this.$store.state.uuid,
      }).then((res) => {
        if (res.code == 200) {
          this.dropDownListTwo = res.data;
        }
      });
      this.list.cr_staff_uuid = "";
    },
    relationChange(val) {
      this.list.correlation_code = val.f2;
    },
    async getDetail() {
      this.skeletonloading = true;
      const res = await staff_relation_config_detail({
        uuid: this.$store.state.uuid,
      });
      if (res.code == 200) {
        this.list = res.data;
      } else {
      }
      this.skeletonloading = false;
    },
    async success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      if (this.list.staff_uuid == this.list.cr_staff_uuid)
        return this.$Message({
          //  员工和被关联员工不能相同
          text: this.$t("message_staff_and_correlated_staff_not"),
          color: "rgb(0,0,0,0.78)",
        });
      if (this.$store.state.uuid) {
        staff_relation_config_edit(this.$deletefield(null, this.list)).then(
          async (res) => {
            if (res.code == 200) {
              this.$Message({
                text: this.$t("message_The_operation_was_successful"),
              });
              await this.getDetail();
              this.$emit("changeReadonly");
            }
          }
        );
      } else {
        staff_relation_config_add({
          ...this.list,
          org_level_uuid: this.$store.state.currentCompany,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t("message_added_successfully") });
            this.$router.push({ name: "staffRelationConfig" });
          }
        });
      }
    },
    async cancel() {
      if (this.$store.state.uuid) {
        await this.getDetail();
        this.$emit("changeReadonly");
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "staffRelationConfig",
            });
          })
          .catch((err) => {});
      }
    },
  },
  validations: {
    list: {
      staff_uuid: {
        required,
      },
      cr_staff_uuid: {
        required,
      },
      effective_utc_datetime: {
        required,
      },
      correlation_code: {
        required,
      },
      correlation_uuid: {
        required,
      },
    },
  },
};
</script>

<style scoped></style>
